var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang5Mian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.333 2C1.597 2 1 2.596 1 3.333v9.333C1 13.403 1.597 14 2.333 14h5.542L7.8 13.9a1.5 1.5 0 01.082-1.9A1.5 1.5 0 019 9.5h1.919a1.5 1.5 0 012.567-1.46L15 9.857V3.333C15 2.596 14.403 2 13.667 2H2.333zm10.438 2.42a.5.5 0 10-.555-.832l-4.05 2.7a.3.3 0 01-.332 0L3.788 3.591a.5.5 0 10-.555.832L7.279 7.12a1.3 1.3 0 001.442 0l4.05-2.7z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 9L14 11H9M10.5 15L9 13h5",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_youxiang5_mian.a0faa09c.svg";
export { SvgTongyongYouxiang5Mian as ReactComponent };